import { createFileRoute, redirect } from '@tanstack/react-router';

import { meQuery } from '../../api/hooks';
import { isStaff } from '../../lib/roles';
import { Sharing } from './sharing';

// Every organization's shares, for MotionSafe staff: the Sharing audit across them all.
export const Route = createFileRoute('/_app/all-sharing')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.fetchQuery(meQuery);
    if (!me || !isStaff(me)) throw redirect({ to: '/overview', search: {} });
  },
  component: Sharing,
});
